import React from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import s from './checkout-print-location-warnings-popup.scss';
const classes = {
  paper: s.paper
};
const CheckoutPrintLocationWarningsPopupComponent = ({
  isOpen,
  onRemoveItem,
  onEditRequest,
  headerText,
  contentText,
  items,
  onClose
}) => {
  const title = headerText || 'Some Print Locations removed';
  return /*#__PURE__*/React.createElement(PopupDialog, {
    dataPopup: "CheckoutPrintLocationWarningsPopup",
    showCloseButton: true,
    open: isOpen,
    contentClass: s.contentClass,
    classes: classes,
    onClose: onClose,
    title: renderTitle(title),
    content: renderContent({
      contentText,
      onClose,
      onRemoveItem,
      onEditRequest,
      items
    })
  });
};
const renderTitle = title => /*#__PURE__*/React.createElement("div", {
  className: s.title
}, title);
const renderContent = ({
  contentText,
  items,
  onRemoveItem,
  onEditRequest
}) => /*#__PURE__*/React.createElement("div", {
  className: s.contentWrapper
}, /*#__PURE__*/React.createElement("span", {
  className: s.contentText
}, contentText), /*#__PURE__*/React.createElement("div", {
  className: s.buttons
}, /*#__PURE__*/React.createElement(Button, {
  type: "primary",
  size: "small",
  onClick: () => onRemoveItem(String(items[0]._id)),
  className: s.cancelButton
}, "Remove"), /*#__PURE__*/React.createElement(Button, {
  type: "primary",
  size: "small",
  onClick: () => onEditRequest(items[0]),
  className: s.button
}, "Edit")));
export default CheckoutPrintLocationWarningsPopupComponent;